<template>
	<div class="dialog_scroll clearfix">
		<div class="taskIng_left">
			<div class="taskIng_infoHead" v-show="questionindex == index" v-for="(item,index) in qusetionlist">
				<img src="@/images/topic_type1.png" v-if="item.topicType == 1" />
				<img src="@/images/topic_type2.png" v-if="item.topicType == 2" />
				<img src="@/images/topic_type3.png" v-if="item.topicType == 3" />
				<img src="@/images/topic_type4.png" v-if="item.topicType == 4" />
				<img src="@/images/topic_type5.png" v-if="item.topicType == 5" />
			</div>
			<div class="taskQuestion_infobody clearfix">
				<questions @singleAnswer='({it,i,index})=>{singleAnswer(it,i,index)}' @multipleAnswer='({it,i,index})=>{multipleAnswer(it,i,index)}' @blanksAnswer='({index})=>{blanksAnswer(index)}' @uploadStatus="(newuploadFlag)=>{uploadFlag = newuploadFlag}" @uploadAnswer='uploadAnswer' @formFileRemove='formFileRemove' :taskType='true' :questionsubmit='true' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
			</div>
			<div class="taskIng_infoFoot">
				<el-button @click="jumpQuestion(questionindex-1,'prve')" :disabled='questionindex<=0 || uploadFlag'>上一题</el-button>
				<el-button @click="jumpQuestion(questionindex+1,'next')" type="primary" :disabled='questionindex>=qusetionlist.length-1 || uploadFlag'>下一题</el-button>
			</div>
		</div>
		<div class="taskIng_right">
			<div class="taskIng_rightHead">答题卡</div>
			<div class="examIng_infobody clearfix">
				<div class="questionAnswer" :class="questionWhere(item,index)" v-for="(item,index) in qusetionlist" @click="jumpQuestion(index,'jump')">
					{{index+1}}
				</div>
			</div>
			<div class="taskIng_infoFoot taskIng_rightFoot">
				<el-button type="primary"  :disabled='loading' @click='overitem'>提交作业</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { getTaskById, getTopicByTaskId, taskCommit } from "@/api/experimentWork.js"
	import questions from '@/components/questions.vue'
	import questionsjs from '@/components/questions.js'
	export default {
		mixins: [questionsjs],
		components: {
			questions
		},
		props: {
			taskId: String,
		},
		data() {
			return {
				uploadFlag: false,
				loading: true,
				loadingtext: '题目加载中...',
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
				taskinfo: {},
			}
		},
		created() {
			this.getTaskitem();
			this.getTaskinfo();
		},
		methods: {
			getTaskitem() {
				var data = {
					id: this.taskId
				}
				getTaskById(data).then(res => {
					if(res.code == "OK" && res.data) {
						this.taskinfo = res.data;
						if(res.data.isFinish) {
							this.$message.info('作业已提交');
							this.$router.back(-1)
						}
					}
				})
			},
			getTaskinfo() {
				var data = {
					id: this.taskId
				}
				getTopicByTaskId(data).then(res => {
					if(res.code == "OK") {
						this.qusetionlist = res.data;
						this.formInit().then(() => {
							this.loading = false;
						})
					}
				})
			},
			overitem() {
				if(!this.uploadFlag) {
					var qusetionlist = this.qusetionlist;
					var questionove = this.questionove;
					if(questionove.length == qusetionlist.length) {
						this.loading = true;
						this.loadingtext = '正在提交...';
						var data = {
							taskId: this.taskId,
							userAnswers: []
						}
						qusetionlist.map(item => {
							var userAnswer = {
								topicId: item.id,
								userAnswerFile: item.filesurl,
								userAnswer: "",
							}
							if(item.topicType == 4 || item.topicType == 5) {
								userAnswer.userAnswer = item.userAnswer
							} else {
								userAnswer.userAnswer = item.choose.join('')
							}

							data.userAnswers.push(userAnswer)
						})
						taskCommit(data).then(res => {
							this.loading = false;
							if(res.code == "OK") {
								this.$store.dispatch('user/addmessage');
								this.$message.success('提交成功');
								this.$emit('taskOver')
							}
						}).catch(err => {
							this.loading = false;
						})
					} else {
						this.$message.error('还有未完成的题目')
					}
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			checkOver() {
				var qusetionlist = this.qusetionlist;
				var questionove = [];
				qusetionlist.map((item, index) => {
					if(item.over == true) {
						questionove.push(index)
					}
				})
				this.questionove = questionove;
			},
			jumpQuestion(questionindex) {
				if(!this.uploadFlag) {
					if(this.questionindex != questionindex) {
						this.questionindex = questionindex
					}
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
		},
	}
</script>